import { API_VERSION_ESYMANDANT, fetchHandler, fileUploadRequestBuilder, limiter } from 'application/api/request_builders'
import { handleApiResponse } from 'application/api/response_handlers'

export const postFiles = (files) => {
    const request = fileUploadRequestBuilder(API_VERSION_ESYMANDANT + '/files/upload', files)

    return limiter.schedule(() => fetchHandler(request.url, request.data))
        .then(handleApiResponse)
}